import React from 'react';

const OverLimitText = (modifiedTotal, makerTotalPrice) =>
  modifiedTotal > makerTotalPrice && (
    <p className='over-limit-text'>
      You are ${((modifiedTotal - makerTotalPrice) / 100).toFixed(2)} above the price limit
    </p>
  );

export default OverLimitText;
